import { render, staticRenderFns } from "./SwitchFunnelType.vue?vue&type=template&id=3282c092&"
import script from "./SwitchFunnelType.vue?vue&type=script&lang=ts&"
export * from "./SwitchFunnelType.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchFunnelType.vue?vue&type=style&index=0&id=3282c092&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports